<template>
<v-layout>
  <v-flex>
    <v-tabs v-model="active">
      <!--
      <v-tab class="alarm" v-if="!srcIdFilter">
        Alarms ({{metricsInAlarm.length}})
      </v-tab>
      -->
      <v-tab>
        Metrics
      </v-tab>
      <!--
      <v-tab-item v-if="!srcIdFilter">
        <v-card flat>
          <v-card-title>
            <v-layout wrap align-center>
              <v-flex xs4>
                <h3 class="headline mb-0">Alarms</h3>
              </v-flex>
              <v-flex xs1>
                <v-btn text icon color="grey lighten-1" @click="refresh" :loading="loadingCollectors || loading"><v-icon>fas fa-sync</v-icon></v-btn>
              </v-flex>
              <v-flex xs1>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-model="search"
                  append-icon="fal fa-search"
                  placeholder="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-select :items="allCollectors" v-model="selectedCollectorId"
                item-text="id" item-value="id" label="Source Collector" clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-data-table :items="metricsInAlarm" :headers="alarmHeaders" :search="search" :loading="loading">
          </v-data-table>
        </v-card>
      </v-tab-item>
      -->
      <v-tab-item>
        <!-- v-for="metricSource in metricSources"
        :key="metricSource"-->

        <v-card flat>
          <v-card-title>
            <v-layout wrap align-center>
              <v-flex xs4>
                <h3 class="headline mb-0">Metrics</h3>
              </v-flex>
              <v-flex xs1>
                <v-btn text icon color="grey lighten-1" @click="refresh" :loading="loadingCollectors || loading"
                ><v-icon>fas fa-sync</v-icon></v-btn>
              </v-flex>
              <v-flex xs1>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-model="search"
                  append-icon="fal fa-search"
                  placeholder="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-select :items="allCollectors" v-model="selectedCollectorId"
                  item-text="id" item-value="id" label="Source Collector" clearable
                ></v-select>
              </v-flex>
              <v-flex xs1>
              </v-flex>
              <v-flex xs5>
                <v-select :items="metricSources" v-model="selectedMetricSources" multiple small-chips deletable-chips
                  label="Metrics Source" clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-data-table
              :items="metricsBySource()"
              :search="search"
              :loading="loading"
              :headers="headers"
              class="elevation-1"
            >
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    keylike: [Number, String],
    srcIdFilter: [Number, String]
  },
  data() {
    return {
      rerender: false,
      active: null,
      search: '',
      loading: false,
      loadingCollectors: false,
      selectedCollectorId: null,
      selectedMetricSources: [],
      pagination : {'sortBy': ['metric'], 'descending': false, 'rowsPerPage': 5},
      headers: [
          {text: 'Source', align: 'left', sortable: true, value: 'source'},
          {text: 'Source Id', align: 'left', sortable: false, value: 'srcId'},
          {text: 'Category', align: 'left', sortable: true, value: 'category'},
          {text: 'Metric', align: 'left', sortable: true, value: 'metric'},
          {text: 'Value', align: 'left', sortable: true, value: 'value'},
          // {text: 'Alarm', align: 'left', sortable: true, value: 'inAlarm'},
          {text: 'Collector', align: 'left', sortable: true, value: 'collector'}
          // {text: 'Key', align: 'left', sortable: true, value: 'key'},
        ]
      // alarmHeaders: [
      //   { text: "Source", value: "source" },
      //   { text: "System Id", value: "srcId" },
      //   { text: "Category", value: "category" },
      //   { text: "Metric", value: "metric" },
      //   { text: "Value", value: "value" },
      //   { text: "Collector", value: "collector"}
      // ]
    }
  },
  watch: {
    orgContext: async function(val) {
      this.loadingCollectors = true
      await this.$store.dispatch('collectors/getCollectors')
      this.loadingCollectors = false
      this.loading = true
      await this.$store.dispatch('collectors/getMetrics', this.keylike)
      this.loading = false
    },
    active: function(currInd) {
      this.rerender = !this.rerender
      // let list = this.sourcesInAlarm
      // let src = this.metricSources ? this.metricSources[currInd || 0] : '-'
      // if (list.length && list.includes(src)) {
      //   this.pagination.sortBy = 'inAlarm'
      //   this.descending = true
      //   this.ascending = false
      // } else {
      //   this.pagination.sortBy = 'metric'
      //   this.descending = false
      //   this.ascending = true
      // }
    }
  },
  computed: {
    ...mapGetters('collectors', {
        // sourcesInAlarm: 'getMetricSourcesInAlarm',
        // metricsInAlarm: "getMetricsInAlarm",
        allCollectors: 'getCollectors'
    }),
    ...mapGetters('user', {
        orgContext: 'getOrgContext'
    }),
    metricSources () {
      return this.$store.getters['collectors/getFilteredMetricSources'](this.srcIdFilter)
    }
  },
  async created () {
    this.loadingCollectors = true
    await this.$store.dispatch('collectors/getCollectors')
    this.loadingCollectors = false
    this.loading = true
    await this.$store.dispatch('collectors/getMetrics', this.keylike)
    this.loading = false
  },
  methods: {
    async refresh () {
        await this.$store.dispatch('collectors/getMetrics', this.keylike)
    },
    metricsBySource() {

        const allMetrics = this.$store.getters['collectors/getFilteredMetrics'](this.srcIdFilter)

        if (!allMetrics) {
          return []
        }

        let filteredData = allMetrics
        if (this.selectedCollectorId) {

          filteredData = _.filter(filteredData, {collector: this.selectedCollectorId})
        }
        if (this.selectedMetricSources.length) {

          filteredData = _.filter(filteredData, (item) => {
            return _.includes(this.selectedMetricSources, item.source)
          })
        }

        return filteredData
    }
  }
}
</script>
<style scope>
.alarm {
  color: red!important;
}
</style>
